module.exports = __webpack_public_path__ + "img/拐点.01f5de09.png";